module.exports = __webpack_public_path__ + "img/image40.924e70de.jpg";